<script>
  import { _, locale as appLocale } from '@sveltia/i18n';
  import { FloatingActionButtonWrapper, Toolbar } from '@sveltia/ui';

  import CopyAssetsButton from '$lib/components/assets/toolbar/copy-assets-button.svelte';
  import DeleteAssetsButton from '$lib/components/assets/toolbar/delete-assets-button.svelte';
  import DownloadAssetsButton from '$lib/components/assets/toolbar/download-assets-button.svelte';
  import EditOptionsButton from '$lib/components/assets/toolbar/edit-options-button.svelte';
  import PreviewAssetButton from '$lib/components/assets/toolbar/preview-asset-button.svelte';
  import UploadAssetsButton from '$lib/components/assets/toolbar/upload-assets-button.svelte';
  import BackButton from '$lib/components/common/page-toolbar/back-button.svelte';
  import { goBack } from '$lib/services/app/navigation';
  import { focusedAsset, selectedAssets } from '$lib/services/assets';
  import {
    canCreateAsset,
    selectedAssetFolder,
    targetAssetFolder,
  } from '$lib/services/assets/folders';
  import { getFolderLabelByCollection, listedAssets } from '$lib/services/assets/view';
  import { env } from '$lib/services/user/env.svelte';
  import { openAuthoring } from '$lib/services/workflow/open-authoring';

  const assets = $derived.by(() => {
    if ($selectedAssets.length) return [...$selectedAssets];
    if ($focusedAsset) return [$focusedAsset];
    return [];
  });

  // Uploading to the media library commits straight to the configured branch rather than going
  // through review, so it’s not something an Open Authoring contributor can do. An asset attached
  // to an entry is committed with that entry, so it’s unaffected
  const uploadDisabled = $derived($openAuthoring || !canCreateAsset($targetAssetFolder));
</script>

<Toolbar variant="primary" aria-label={_('folder')}>
  {#if env.isSmallScreen}
    <BackButton
      aria-label={_('back_to_asset_folder_list')}
      onclick={() => {
        goBack('/assets');
      }}
    />
  {/if}
  <h2 role="none">
    {#key appLocale.current}
      <bdi>{$selectedAssetFolder ? getFolderLabelByCollection($selectedAssetFolder) : ''}</bdi>
    {/key}
    {#if !env.isSmallScreen && $selectedAssetFolder?.internalPath !== undefined}
      <span role="none" dir="ltr">/{$selectedAssetFolder.internalPath}</span>
    {/if}
  </h2>
  {#if !(env.isSmallScreen || env.isMediumScreen)}
    <PreviewAssetButton asset={$focusedAsset} />
    <CopyAssetsButton assets={$focusedAsset ? [$focusedAsset] : []} />
    <DownloadAssetsButton {assets} />
    <DeleteAssetsButton
      {assets}
      buttonDescription={_('delete_selected_assets', { values: { count: assets.length } })}
      dialogDescription={_(
        assets.length > 1 && assets.length === $listedAssets.length
          ? 'confirm_deleting_all_assets'
          : 'confirm_deleting_selected_assets',
        { values: { count: assets.length } },
      )}
    />
    <EditOptionsButton asset={$focusedAsset} />
  {/if}
  <FloatingActionButtonWrapper>
    {#if !env.isSmallScreen || ($listedAssets.length && !uploadDisabled)}
      <UploadAssetsButton label={env.isSmallScreen ? undefined : _('upload')} />
    {/if}
  </FloatingActionButtonWrapper>
</Toolbar>
